import React from 'react'

// styles
import { stackContainer, stackItem } from './styles/styles.css'

// components
import { ImageCircle } from './ImageCircle.component'
import { ImageSource } from '@/shared/interfaces/images'
import { AnimateContainer } from '../container/AnimateContainer.component'

interface Props {
  srcs: ImageSource[]
  stackCss?: string[]
  imageContainerCss?: string[]
  imageCss?: string[]
  size?: number | string
  leftPosition?: number
  withAnimation?: boolean
}

export const StackImageCircles: React.FC<Props> = ({
  srcs,
  imageContainerCss = [],
  imageCss = [],
  size = '100%',
  leftPosition = 35,
  withAnimation = false,
}) => {
  const getPosition = (index: number) => {
    if (index > 0) {
      return `-${index * leftPosition}%`
    }
  }

  return (
    <div className={stackContainer}>
      {srcs.map((src, index) => (
        <div
          style={{
            transform: `translateX(${getPosition(index)})`,
          }}
          key={index}
          className={stackItem}
        >
          {withAnimation && (
            <AnimateContainer
              type="bounceIn"
              delay={index * 150}
              setOpacityNone={true}
            >
              <ImageCircle
                src={src.src}
                alt={src.alt}
                imageContainerCss={imageContainerCss}
                imageCss={imageCss}
                size={size}
                key={index}
              />
            </AnimateContainer>
          )}
          {!withAnimation && (
            <ImageCircle
              src={src.src}
              alt={src.alt}
              imageContainerCss={imageContainerCss}
              imageCss={imageCss}
              size={size}
              key={index}
            />
          )}
        </div>
      ))}
    </div>
  )
}
